var React = require('react');

function AiTraining (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.9799 6.0201L32 0L30.0201 6.0201L24 8L30.0201 9.9799L32 16L33.9799 9.9799L40 8L33.9799 6.0201ZM22.4548 17.5452L18 4L13.5452 17.5452L0 22L13.5452 26.4548L18 40L22.4548 26.4548L36 22L22.4548 17.5452Z","fill":"#676D73"}));
}

AiTraining.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = AiTraining;

AiTraining.default = AiTraining;
